import styled from "styled-components";

export const AnswerPartContainer = styled.div`
  margin: 0.5rem;
`
